import { useState, useEffect, useRef } from 'react'

export const useCounter = (target, isVisible = true, delay = 0) => {
  const [count, setCount] = useState(0)
  const hasStartedRef = useRef(false)
  const animationRef = useRef()
  const startTimeRef = useRef()

  useEffect(() => {
    if (isVisible && !hasStartedRef.current) {
      hasStartedRef.current = true
      const timer = setTimeout(() => {
        startTimeRef.current = performance.now()
        
        const animate = (currentTime) => {
          const elapsed = currentTime - startTimeRef.current
          const duration = 2000 // 2 seconds
          const progress = Math.min(elapsed / duration, 1)
          
          // Ease out cubic formula
          const eased = 1 - Math.pow(1 - progress, 3)
          const currentCount = Math.floor(eased * target)
          
          setCount(currentCount)
          
          if (progress < 1) {
            animationRef.current = requestAnimationFrame(animate)
          }
        }
        
        animationRef.current = requestAnimationFrame(animate)
      }, delay)
      
      return () => {
        clearTimeout(timer)
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current)
        }
      }
    }
  }, [isVisible, target, delay])

  return count
}
